import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

type ServicedeskPortalResponse = {
	id: string;
};

export type ServicedeskPortalService = (projectId: number) => Promise<ServicedeskPortalResponse>;

const fetchServiceDeskPortal = (projectId: number) => {
	const url = `/rest/servicedeskapi/servicedesk/projectId:${projectId}`;
	return fetchJson(url);
};

export default fetchServiceDeskPortal;
